import { render, staticRenderFns } from "./xitonggonggao.vue?vue&type=template&id=2580c53e&scoped=true"
import script from "./xitonggonggao.vue?vue&type=script&lang=js"
export * from "./xitonggonggao.vue?vue&type=script&lang=js"
import style0 from "./xitonggonggao.vue?vue&type=style&index=0&id=2580c53e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2580c53e",
  null
  
)

export default component.exports